import React, { useContext } from 'react';
import T from 'prop-types';
import { isEmpty } from 'lodash-es';

import NotificationAlertButton from '../../../../../components/NotificationAlertButton';
import ExportsViewContext from '../../../../../components/AdvancedExportModal/ExportsViewContext';
import {
  Menu,
  MenuItem,
  MenuDivider,
  MenuButton,
  useMenuProps,
} from '../../../../../components/DropdownSet';

import { isUnified } from '../../../../../utils/helpers';
import { allowedExportPages, initParams } from '../../../app-overview/_shared/config/export-params';

const normalizedStore = {
  google_play: 'Google',
  itunes_connect: 'iOS',
};

const emptyArray = [];

const AlertsDropdown = ({
  store,
  notification,
  app,
  allowNotifications = true,
  prependCustomOptions = emptyArray,
  appendCustomOptions = emptyArray,
}) => {
  const menuProps = useMenuProps({
    align: 'end',
    menuStyle: { width: 238 },
    menuClassName: 'alerts-dropdown',
  });

  const { openAdvancedExportModal } = useContext(ExportsViewContext);

  const alerts = (() => {
    if (isEmpty(notification)) {
      return [{
        metaData: {
          ref_no: app.ref_nos_by_store[isUnified(store) ? 'both' : store],
          store,
          kind: 'app',
        },
        notification,
        label: 'Create Alert',
        icon: 'hicon-alert-plus',
      }];
    }

    return (isUnified(store) ? ['itunes_connect', 'google_play'] : [store]).map((currentStore) => {
      const currentNotification = notification[currentStore];
      return {
        metaData: {
          ref_no: app.ref_nos_by_store[currentStore],
          store: currentStore,
          kind: 'app',
        },
        notification: currentNotification,
        label: currentNotification ? `Modify ${normalizedStore[currentStore]} Alert` : `Create Alert (${normalizedStore[currentStore]})`,
        icon: currentNotification ? 'hicon-edit-2' : 'hicon-alert-plus',
      };
    });
  })();

  return (
    <Menu
      menuButton={(
        <MenuButton
          shape="square"
          caret={false}
          variant="light"
          className="alerts-dropdown-btn"
        >
          <i className="hicon-more-vert" />
        </MenuButton>
      )}
      {...menuProps}
    >
      {prependCustomOptions.map(({ key, item }, index) => (
        <MenuItem key={key || index} className="additional-options additional-options--prepend">
          {item}
        </MenuItem>
      ))}
      {!isEmpty(prependCustomOptions) && <MenuDivider fullWidth dense />}
      {alerts.map(item => (
        <MenuItem key={item.label} className="create-alert">
          <NotificationAlertButton
            showButtonName
            enableTooltip={false}
            metaData={item.metaData}
            notification={item.notification}
            allowNotifications={allowNotifications}
            variant="light"
            customBtnName={item.label}
            iconClassName={item.icon}
          />
        </MenuItem>
      ))}
      {!isEmpty(appendCustomOptions) && <MenuDivider fullWidth dense />}
      {initParams?.permissions?.allowAdvancedExportModal
        && allowedExportPages.includes(initParams.pageName) && (
          <MenuItem
            className="additional-options additional-options--append additional-options__export"
            onClick={openAdvancedExportModal}
          >
            <span>
              <i className="hicon-download-thin" />
              {initParams?.permissions?.hideLegacyExport ? 'Export Data' : 'Advanced Export'}
            </span>
          </MenuItem>
      )}
      {appendCustomOptions.map(({ key, item }, index) => (
        <MenuItem key={key || index} className="additional-options additional-options--append">
          {item}
        </MenuItem>
      ))}
    </Menu>
  );
};

AlertsDropdown.propTypes = {
  notification: T.object,
  store: T.string,
  app: T.object,
  allowNotifications: T.bool,
  prependCustomOptions: T.array,
  appendCustomOptions: T.array,
};

export default AlertsDropdown;
